// extracted by mini-css-extract-plugin
export default {"sliderContainer":"sxkQrgU8","slider":"_2Ho1Vjgx"};